import { usePlatformConfig } from '~/context/platform'
import { isHouseholdRedemptionEnabledForOpCo } from '~/utils/household'

/** Whether orders in the current market can be paid from the household Avios balance */
const useIsHouseholdRedemptionEnabled = (): boolean => {
  const { opCo } = usePlatformConfig()
  return isHouseholdRedemptionEnabledForOpCo(opCo)
}

export default useIsHouseholdRedemptionEnabled
